import { render, staticRenderFns } from "./PatrolPoints.vue?vue&type=template&id=504c123e&scoped=true"
import script from "./PatrolPoints.vue?vue&type=script&lang=js"
export * from "./PatrolPoints.vue?vue&type=script&lang=js"
import style0 from "./PatrolPoints.vue?vue&type=style&index=0&id=504c123e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c123e",
  null
  
)

export default component.exports